module.exports = __webpack_public_path__ + "static/media/SamsungFooter2.92aea898.jpg";